{
  "filters": {
    "address": "Dirección",
    "update": "Actualizar",
    "name": "Nombre de la institución",
    "state": "Estado",
    "any": "Cualquiera",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "awaitingReview": "En espera de revisión",
    "requestedDate": "Fecha solicitada",
    "approvedDate": "Fecha aprobada",
    "daysWaiting": "Días de espera",
    "document": "Documento",
    "transitNumber": "Número de tránsito",
    "institutionNumber": "Número de institución",
    "bankAccountNumber": "Número de cuenta bancaria",
    "actions": "Acciones",
    "stateOptions": {
      "AWAITING_REVIEW": "En espera de revisión",
      "APPROVED": "Aprobado",
      "REJECTED": "Rechazado"
    }
  },
  "institutionTransitions": {
    "approve": "Aprobar",
    "reject": "Rechazar"
  },
  "update": "Actualizar",
  "moderateInstitution": "¿Está seguro?",
  "confirmationDialogTitle": "¿Confirma que desea {{transition}} esta institución?",
  "institutionPrefix": "Institución -",
  "addModal": {
    "title": "Crear institución nueva",
    "address": "Dirección"
  }
}
